import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { UserMessageService } from '../messages/user-message.service';
import { resourceText } from '../services/localization';

/** Only currently visible loaders receive an unhandled failure. No stale error replay. */
@Injectable({ providedIn: 'root' })
export class LoadingRecoveryService {
  private loaders = new Set<() => boolean>();
  private noticeShown = false;

  register(recover: () => boolean): () => void {
    this.loaders.add(recover);
    return () => this.loaders.delete(recover);
  }

  failVisibleLoaders(): boolean {
    let recovered = false;
    for (const recover of this.loaders) recovered = recover() || recovered;
    return recovered;
  }

  reportUnhandled(injector: Injector): void {
    // Let local catch/finally handlers and Angular remove finished loaders first.
    queueMicrotask(() => {
      if (this.failVisibleLoaders() || this.noticeShown) return;
      this.noticeShown = true;
      injector.get(UserMessageService).show(
        resourceText('WE_COULD_NOT_CONFIRM_THE_CHANGE_PLEASE_TRY_AGAIN'), 'error', resourceText('ACTION_NEEDED'));
      setTimeout(() => this.noticeShown = false, 3000);
    });
  }
}

@Injectable()
export class LoadingErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) { super(); }
  override handleError(error: unknown): void {
    super.handleError(error);
    this.injector.get(LoadingRecoveryService).reportUnhandled(this.injector);
  }
}
